<template>
  <div class="passport" :class="{ styleChanged: imageUrl }">
    <button class="goBack" @click="goBack()">
      <i class="fas fa-chevron-left"></i>
      {{ $t("authorization.back") }}
    </button>
    <form @submit.prevent="humanPassport()">
      <div class="content">
        <div class="explanation">
          <h1>{{ $t("authorization.infPassport") }}</h1>
          <p>{{ $t("authorization.contentPassport") }}</p>
        </div>
        <div class="image">
          <img :src="imageUrl" v-if="imageUrl" />
          <h3>
            {{ $t("authorization.getImage") }}
          </h3>
          <h4>{{ $t("authorization.imageFormat") }}</h4>
          <h2 v-if="imageUrl">
            {{ $t("authorization.image") }}: <span> {{ imageName }} </span>
          </h2>
          <input
            @input="setImage()"
            ref="image"
            type="file"
            class="file"
            :label="$t('authorization.selectImage')"
            accept="image/png, image/jpeg"
          />
          />
        </div>
      </div>
      <button :disabled="!imageUrl" type="submit" class="continue">
        {{ $t("authorization.continue") }}
      </button>
      <button class="mainPage">{{ $t("authorization.mainPage") }}</button>
    </form>
  </div>
</template>

<script>
import { ref } from "vue";
import { useStore } from 'vuex';
export default {
  /*  eslint-disable */
  setup(props, { emit }) {
    /* eslint-enable */
    const store = useStore();
    const image = ref(null);
    const imageUrl = ref(null);
    const imageName = ref("");

    const setImage = () => {
      const file = image.value.files[0];
      imageUrl.value = URL.createObjectURL(file);

      const fileName = image.value.files[0].name;

      imageName.value = fileName;
      console.log(imageName);
    };

    const humanPassport = () => {
      if (!imageUrl.value) {
        alert("please send your passport image");
        return;
      }

      store.commit("updateUserModel", {passport: image.value.files[0]});

      emit("submitForm");
    };

    const goBack = () => {
      emit("goBack");
    };

    return {
      image,
      imageUrl,
      humanPassport,
      setImage,
      imageName,
      goBack,
    };
  },
};
</script>

<style lang="scss" scoped>
.passport {
  width: 100%;
  .goBack {
    color: var(--explanation-color);
    background: transparent;
    font-size: 1.1em;
    line-height: 1.2em;
    margin-left: 2rem;
    margin-top: 1rem;
    cursor: pointer;
  }
  form {
    display: flex;
    flex-direction: column;
    .content {
      display: flex;
      justify-content: space-around;
      align-items: centere;

      .explanation {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 17rem;
        h1 {
          grid-area: title;
          color: var(--title-color);
          font-size: 1.1em;
          line-height: 1.1em;
          font-weight: 400;
        }
        p {
          grid-area: explanation;
          color: var(--content-opacity);
          font-size: 0.9em;
          line-height: 1em;
          font-weight: 400;
          margin-top: 0.625rem;
        }
      }
      .image {
        grid-area: imageBlock;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 16rem;
        height: 12.5rem;
        border: 1px dashed #6c8fba;
        text-align: center;
        img {
          width: 13rem;
          height: 8rem;
        }

        h3 {
          color: var(--content-opacity);
          font-size: 1.2em;
          line-height: 1.2em;
          font-weight: 400;
          grid-area: imageTitle;
        }
        h4 {
          color: var(--title-light);
          font-size: 0.9em;
          line-height: 1em;
          font-weight: 400;
          margin-top: 0.313rem;
          grid-area: imageCont;
        }
        .file {
          width: 9rem;
          height: 3rem;
          font-size: 1.1em;
          line-height: 1.2em;
          font-weight: 400;
          cursor: pointer;
          position: relative;
          margin-top: 1.8rem;
          &::after {
            content: attr(label);
            color: var(--primary-font-color);
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: var(--explanation-color);
          }
        }
      }
    }
    .continue {
      width: 21rem;
      height: 3.6rem;
        border: 1px solid rgba(29, 82, 149, 1);
        color: rgba(29, 82, 149, 1);
      margin-left: auto;
      margin-right: auto;
      margin-top: 3.2rem;
      background: transparent;
      outline: none;
      cursor: pointer;
      &:disabled{
        opacity: 0.3;
        pointer-events: none;
      }
    }
    .mainPage {
      grid-area: mainPage;
      font-size: 1.2em;
      line-height: 1.2em;
      background: transparent;
      color: var(--back-btn);
      border-bottom: 1px solid rgba(128, 128, 128, 1);
      margin-bottom: 1.4rem;
      margin-top: 1rem;
      width: max-content;
      margin-left: auto;
      margin-right: auto;
      cursor: pointer;
    }
  }

  &.styleChanged {
    form {
      .image {
        border: none;
        height: 100%;
        display: grid;
        grid-template-areas:
          "img"
          "imageName"
          "file";
        text-align: left;
        h3 {
          display: none;
        }
        h4 {
          display: none;
        }
        h2 {
          color: var(--title-opacity-color);
          grid-area: imageName;
          margin-bottom: 1.5rem;
          margin-top: 0.313rem;
          span {
            color: var(--explanation-color);
          }
        }
        img {
          grid-area: img;
        }
        .file {
          margin-top: 0;
          grid-area: file;
        }
      }

    }
  }
}

@media screen and (max-width: 1366px) {
  .passport {
    width: 100%;

    form {
      margin-top: 3rem;
      .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .explanation {
          margin-left: 3rem;
        }
        .image {
          border: none;
          display: flex;
          flex-direction: column-reverse;
          justify-content: flex-start;
          margin-top: 2.9rem;
          height: max-content;
          h3 {
            display: none;
          }
          .file {
            margin-top: 0;
          }
        }
      }
      .continue {
        margin-top: 4.4rem;
      }
      .mainPage {
        margin-bottom: 1.4rem;
      }
    }

    &.styleChanged {
      form {
        .image {
          display: grid;
          grid-template-areas:
            "img imageName"
            "img file";
          grid-template-columns: 50% 50%;
          width: 100%;
          h2 {
            color: var(--title-opacity-color);
            grid-area: imageName;
            margin-bottom: 1.5rem;
            margin-top: 0.313rem;
            text-align: center;
            span {
              color: var(--explanation-color);
            }
          }
          img {
            grid-area: img;
            margin-left: 2rem;
          }
          .file {
            margin-top: 0;
            grid-area: file;
            margin-left: 4.5rem;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 540px) {
  .passport {
    width: 100%;
    form {
      width: 100%;
      .content {
        margin-bottom: 9rem;
      }
      .continue {
        width: 16rem;
        margin-top: 0;
      }
    }
    &.styleChanged {
      form {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .content {
          margin-bottom: 1.2rem;
          .image {
            display: grid;
            grid-template-areas:
              "img imageName"
              "file file"
              "imageFormat imageFormat";
            grid-template-columns: auto;
            width: 100%;
            position: relative;
            h4 {
              grid-area: imageFormat;
              display: flex;
              position: relative;
              left: 50%;
            }
            h2 {
              color: var(--title-opacity-color);
              grid-area: imageName;
              margin-bottom: 1.5rem;
              margin-top: 0;
              text-align: left;
              width: 6rem;
              height: 2rem;
              overflow: hidden;
              margin-left: 0.313rem;
              position: absolute;
              top: 0;
              span {
                color: var(--explanation-color);
              }
            }
            img {
              grid-area: img;
              margin-left: 1rem;
            }
            .file {
              margin-top: 0;
              grid-area: file;
              margin-left: auto;
              margin-top: 1.3rem;
            }
          }
        }
      }
    }
  }
}
</style>
